module.exports = __webpack_public_path__ + "img/paishui.fcea19fc.png";